import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

const TOKEN_VERSION = 'v3';
const storedVersion = localStorage.getItem('ae_token_version');
if (storedVersion !== TOKEN_VERSION) {
  ['ae_access_token','ae_refresh_token','ae_user','ae_admin',
   'autoelite-user','autoelite-admin','autoelite-bookings',
   'ae_all_bookings','ae_admin_notifs','ae_last_sms',
  ].forEach(k => localStorage.removeItem(k));
  localStorage.setItem('ae_token_version', TOKEN_VERSION);
  console.info('[AutoElite Admin] Cleared stale tokens — please sign in again.');
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);